import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RiDeleteBinLine } from "react-icons/ri";
import { IoIosArrowForward, IoIosArrowBack } from "react-icons/io";
import {
  addBundleToCompare,
  clearBundlesToCompare,
  selectBundlesToCompare,
  selectCurrentAxisFilters,
  setCurrentFiltersStepperStep,
  setShowOnlyDifferentValues
} from "../../../../Retrofit/store/slices/retrofit";
import Button from "../../../../Common/components/Buttons/Button/Button";
// MSC-1778: Component ComparatorLine must be commonalized
import ComparatorLine from "./ComparatorLine";
import t from "../../../../Common/utils/translation/translator";
import useCheckMobileScreen from "../../../../Common/utils/useCheckMobileScreen";
import getUtilizationPercentage from "../../../../Retrofit/utils/utilizationPercentage";
import getInertiaRatio from "../../../../Retrofit/utils/inertiaRatio";

const BundleComparator = ({ onSelectBundle }) => {
  const fillDynamicBundlesToCompare = () => {
    if (isMobile) {
      return mobileBundlesToCompare;
    }
    return bundlesToCompare;
  };

  const bundlesToCompare = useSelector(selectBundlesToCompare);
  const [mobileBundlesToCompare, setMobileBundlesToCompare] = useState([bundlesToCompare[0], bundlesToCompare[1]]);
  const [firstBundleNum, setFirstBundleNum] = useState("1/3");
  const [secondBundleNum, setSecondBundleNum] = useState("2/3");

  const isMobile = useCheckMobileScreen();

  const dynamicBundlesToCompare = fillDynamicBundlesToCompare();
  const motors = dynamicBundlesToCompare.map((bundle) => bundle.motor);
  const drives = dynamicBundlesToCompare.map((bundle) => bundle.drive);
  const gearboxes = dynamicBundlesToCompare.map((bundle) => bundle.gearbox);
  const adaptationKits = dynamicBundlesToCompare.map((bundle) => bundle.adaptationKit);
  const hasGearboxes = gearboxes.some((gearbox) => gearbox !== undefined);
  const hasAdaptationKits = adaptationKits.some((adaptationKit) => adaptationKit !== undefined);

  const [showBundles, setShowBundles] = useState(true);
  const [showDrives, setShowDrives] = useState(false);
  const [showMotors, setShowMotors] = useState(false);
  const [showGearboxes, setShowGearboxes] = useState(false);
  const [showAdaptationKits, setShowAdaptationKits] = useState(false);

  const langTrad = window.msizerConfiguration.locale === "en-WW" ? "en-GB" : window.msizerConfiguration.locale;
  const filters = useSelector(selectCurrentAxisFilters);

  const dispatch = useDispatch();

  const changeFirstBundle = () => {
    if (JSON.stringify(mobileBundlesToCompare) === JSON.stringify([bundlesToCompare[0], bundlesToCompare[1]])) {
      setMobileBundlesToCompare([bundlesToCompare[1], bundlesToCompare[2]]);
      setFirstBundleNum("2/3");
      setSecondBundleNum("3/3");
      return;
    }
    if (JSON.stringify(mobileBundlesToCompare) === JSON.stringify([bundlesToCompare[1], bundlesToCompare[2]])) {
      setMobileBundlesToCompare([bundlesToCompare[0], bundlesToCompare[2]]);
      setFirstBundleNum("1/3");
      setSecondBundleNum("3/3");
      return;
    }
    if (JSON.stringify(mobileBundlesToCompare) === JSON.stringify([bundlesToCompare[0], bundlesToCompare[2]])) {
      setMobileBundlesToCompare([bundlesToCompare[1], bundlesToCompare[2]]);
      setFirstBundleNum("2/3");
      setSecondBundleNum("3/3");
    }
  };

  const changeSecondBundle = () => {
    if (JSON.stringify(mobileBundlesToCompare) === JSON.stringify([bundlesToCompare[0], bundlesToCompare[1]])) {
      setMobileBundlesToCompare([bundlesToCompare[0], bundlesToCompare[2]]);
      setFirstBundleNum("1/3");
      setSecondBundleNum("3/3");
      return;
    }
    if (JSON.stringify(mobileBundlesToCompare) === JSON.stringify([bundlesToCompare[0], bundlesToCompare[2]])) {
      setMobileBundlesToCompare([bundlesToCompare[0], bundlesToCompare[1]]);
      setFirstBundleNum("1/3");
      setSecondBundleNum("2/3");
      return;
    }
    if (JSON.stringify(mobileBundlesToCompare) === JSON.stringify([bundlesToCompare[1], bundlesToCompare[2]])) {
      setMobileBundlesToCompare([bundlesToCompare[0], bundlesToCompare[1]]);
      setFirstBundleNum("1/3");
      setSecondBundleNum("2/3");
    }
  };

  const getValues = (index, from) =>
    from.map((elt) => {
      if (Array.isArray(elt?.[index])) {
        return elt?.[index]?.join(", ");
      }
      if (!Number(elt?.[index])) {
        return elt?.[index]?.toString() || "N/A";
      }
      return Number(Math.round(elt?.[index] * 100) / 100)?.toString() || "";
    });

  Object.byString = function (o, s) {
    s = s.replace(/\[(\w+)\]/g, ".$1"); // convert indexes to properties
    s = s.replace(/^\./, ""); // strip a leading dot
    const a = s.split(".");
    for (let i = 0, n = a.length; i < n; ++i) {
      var k = a[i];
      if (k in o) {
        o = o[k];
      } else {
        return;
      }
    }
    return o;
  };

  const getValuesTranslated = (index, from) => {
    const res = [];
    from.forEach((elt) => {
      const tmp = Object.byString(elt, index);
      res.push(tmp);
    });
    return res;
  };

  const getValuesFromTranslation = (data, id, lang) => {
    let values = [];

    data.forEach((elt) => {
      let isFound = false;
      elt.translationData.forEach((translationDataGroup) => {
        translationDataGroup.catalogue_product.characteristic_group_list.characteristic_group.forEach(
          (characteristicGroup) => {
            characteristicGroup.characteristic_list.characteristic.forEach((characteristic) => {
              if (characteristic.id.endsWith(id) && values.length < data.length) {
                values.push(characteristic.valueIds.map((item) => item.translation[lang]).join(", "));
                isFound = true;
              }
            });
          }
        );
      });
      if (!isFound && values.length < data.length) {
        values.push("N/A");
      }
    });
    return values;
  };

  const handleCLearBundlesToCompare = () => {
    dispatch(clearBundlesToCompare());
    dispatch(setCurrentFiltersStepperStep(1));
  };

  // console.log("drives:", drives);
  // console.log("motors:", motors);
  // console.log("gearboxes:", gearboxes);
  // console.log("adaptationKits:", adaptationKits);

  const handleSelectBundle = (bundle) => {
    onSelectBundle(bundle);
  };

  const handleRemoveSolutionFromCompare = (bundle) => {
    // if it's the last bundle, go back to results
    if (bundlesToCompare.length === 1) {
      dispatch(setCurrentFiltersStepperStep(1));
    }
    dispatch(addBundleToCompare(bundle));
  };

  useEffect(() => {
    dispatch(setShowOnlyDifferentValues(false));
  }, []);

  return (
    <div className="md:border-[1px] md:border-solid md:border-gray-100 md:shadow-lg text-gray-600 flex flex-col space-y-5 py-4">
      <div className="mx-5 flex justify-between items-center">
        <span className="font-bold">{t("msizer.ui.compare.title")}</span>
        <Button
          id="retrofit-compare-button-clear"
          textColor="blue"
          disabled={dynamicBundlesToCompare.length === 0}
          onClick={handleCLearBundlesToCompare}
        >
          <RiDeleteBinLine />
          <span>{t("msizer.ui.compare.clear_all")}</span>
        </Button>
      </div>

      {bundlesToCompare.length === 0 && <div className="text-center py-10">Please select bundles to compare</div>}

      {bundlesToCompare.length > 0 && (
        <div className="text-xs">
          <ComparatorLine
            title={t("msizer.ui.compare.select_bundle")}
            type="header"
            headerBundles={dynamicBundlesToCompare}
            onSelect={(bundle) => {
              handleSelectBundle(bundle);
            }}
            onRemoveSolutionFromCompare={(bundle) => {
              handleRemoveSolutionFromCompare(bundle);
            }}
          />

          {/* BUNDLES */}
          <ComparatorLine
            title={t("msizer.ui.bundle").toUpperCase()}
            opened={showBundles}
            isSectionHeader
            values={dynamicBundlesToCompare.map(() => "")}
            onClick={() => setShowBundles(!showBundles)}
          />

          {showBundles && (
            <>
              {/* <ComparatorLine
                title={t("msizer.ui.nominal_torque")}
                values={dynamicBundlesToCompare.map((bundle) =>
                  Number(Math.round(bundle.nominalTorque * 100) / 100)
                )}
                unit={t("msizer.ui.unit.nm")}
              /> */}

              <ComparatorLine
                title={t("msizer.ui.nominal_torque")}
                values={dynamicBundlesToCompare.map((bundle) => {
                  return getUtilizationPercentage(
                    "nominalTorque",
                    Number(Math.round(bundle.nominalTorque * 100) / 100),
                    filters,
                    t("msizer.ui.unit.nm")
                  );
                })}
              />

              {/* <ComparatorLine
                title={t("msizer.ui.nominal_speed")}
                values={dynamicBundlesToCompare.map((bundle) =>
                  Number(Math.round(bundle.nominalSpeed * 100) / 100)
                )}
                unit={t("msizer.ui.unit.rpm")}
              /> */}

              <ComparatorLine
                title={t("msizer.ui.nominal_speed")}
                values={dynamicBundlesToCompare.map((bundle) => {
                  return getUtilizationPercentage(
                    "nominalSpeed",
                    Number(Math.round(bundle.nominalSpeed * 100) / 100),
                    filters,
                    t("msizer.ui.unit.rpm")
                  );
                })}
              />

              <ComparatorLine
                title={t("msizer.ui.bundle_inertia")}
                values={dynamicBundlesToCompare.map((bundle) => bundle.inertia?.toFixed(2))}
              />

              <ComparatorLine
                title={t("msizer.ui.inertia_ratio")}
                values={dynamicBundlesToCompare.map((bundle) =>
                  getInertiaRatio(filters?.applicationDataFilter?.loadInertia, bundle.inertia)
                )}
              />

              <ComparatorLine
                title={t("msizer.ui.length")}
                values={dynamicBundlesToCompare.map((bundle) => bundle.length)}
                unit={t("msizer.ui.unit.mm")}
              />
            </>
          )}

          {/* DRIVE */}
          <ComparatorLine
            title={t("msizer.ui.drive").toUpperCase()}
            opened={showDrives}
            isSectionHeader
            values={drives.map((drive) => drive.commercialReference)}
            onClick={() => setShowDrives(!showDrives)}
          />

          {showDrives && (
            <>
              <ComparatorLine isProductImages values={drives.map((drive) => drive.commercialReference)} />
              <ComparatorLine
                title={t("msizer.ui.drive_filters.range_of_product")}
                values={getValues("rangeOfProduct", drives)}
              />

              <ComparatorLine title={t("msizer.ui.drive_filters.drive_type")} values={getValues("type", drives)} />

              <ComparatorLine
                title={t("msizer.ui.drive_filters.component_type")}
                values={getValuesFromTranslation(drives, "D_DEVICE_SHORT_NAME", langTrad)}
              />

              <ComparatorLine
                title={t("msizer.ui.drive_filters.switching_frequency")}
                values={getValues("switchingFreq", drives)}
                unit={t("msizer.ui.unit.khz")}
              />

              <ComparatorLine
                title={t("msizer.ui.drive_filters.format")}
                values={getValuesFromTranslation(drives, "D_DRIVE_DESIGN", langTrad)}
              />

              <ComparatorLine
                title={t("msizer.ui.drive_filters.output_current")}
                values={getValuesFromTranslation(drives, "A_CONTINUOUS_OUTPUT_CURRENT", langTrad)}
              />

              <ComparatorLine
                title={t("msizer.ui.drive_filters.supply_voltage")}
                values={getValues("outputVoltages", drives)}
              />

              <ComparatorLine
                title={t("msizer.ui.drive_filters.nb_phases")}
                values={getValuesFromTranslation(drives, "D_NETWORK_NUMBER_OF_PHASES", langTrad)}
              />

              <ComparatorLine
                title={t("msizer.ui.drive_filters.communication_interfaces")}
                values={getValuesFromTranslation(drives, "COMMUNICATION_INTERFACE", langTrad)}
              />

              <ComparatorLine
                title={t("msizer.ui.drive_filters.nominal_power")}
                values={getValuesFromTranslation(drives, "A_NOMINAL_POWER", langTrad)}
              />

              <ComparatorLine
                title={t("msizer.ui.drive_filters.output_current_3s_peak")}
                values={getValuesFromTranslation(drives, "A_OUTPUT_CURRENT_3S_PEAK", langTrad)}
              />

              <ComparatorLine
                title={t("msizer.ui.drive_filters.line_current")}
                values={getValuesFromTranslation(drives, "A_LINE_CURRENT", langTrad)}
              />

              <ComparatorLine
                title={t("msizer.ui.drive_filters.width")}
                values={getValues("width", drives)}
                unit={t("msizer.ui.unit.mm")}
              />

              <ComparatorLine
                title={t("msizer.ui.drive_filters.height")}
                values={getValues("height", drives)}
                unit={t("msizer.ui.unit.mm")}
              />

              <ComparatorLine
                title={t("msizer.ui.drive_filters.depth")}
                values={getValues("depth", drives)}
                unit={t("msizer.ui.unit.mm")}
              />

              <ComparatorLine
                title={t("msizer.ui.drive_filters.net_weight")}
                values={getValues("netWeight", drives)}
                unit={t("msizer.ui.unit.kg")}
              />
            </>
          )}

          {/* MOTOR */}
          <ComparatorLine
            title={t("msizer.ui.motor").toUpperCase()}
            isSectionHeader
            opened={showMotors}
            values={motors.map((motor) => motor.commercialReference)}
            onClick={() => setShowMotors(!showMotors)}
          />
          {showMotors && (
            <>
              <ComparatorLine isProductImages values={motors.map((motor) => motor.commercialReference)} />
              <ComparatorLine
                title={t("msizer.ui.motor_filters.component_type")}
                values={getValuesFromTranslation(motors, "D_PRODUCT_OR_COMPONENT_TYPE", langTrad)}
              />
              <ComparatorLine title={t("msizer.ui.motor_filters.motor_type")} values={getValues("type", motors)} />
              <ComparatorLine
                title={t("msizer.ui.motor_filters.flange_size")}
                values={getValues("flangeSize", motors)}
                unit={t("msizer.ui.unit.mm")}
              />
              <ComparatorLine
                title={t("msizer.ui.motor_filters.number_of_stacks")}
                values={getValues("numberOfStacks", motors)}
              />
              <ComparatorLine
                title={t("msizer.ui.motor_filters.nominal_torque_of_motor")}
                values={getValuesFromTranslation(motors, "A_NOMINAL_TORQUE", langTrad)}
              />

              <ComparatorLine
                title={t("msizer.ui.motor_filters.continuous_stall_torque")}
                values={getValues("continuousStallTorque", motors)}
                unit={t("msizer.ui.unit.a")}
              />
              <ComparatorLine
                title={t("msizer.ui.motor_filters.peak_stall_torque")}
                values={getValues("peakStallTorque", motors)}
                unit={t("msizer.ui.unit.nm")}
              />
              <ComparatorLine
                title={t("msizer.ui.motor_filters.nominal_speed_of_motor")}
                values={getValuesFromTranslation(motors, "A_NOMINAL_SPEED", langTrad)}
              />
              <ComparatorLine
                title={t("msizer.ui.motor_filters.maximum_mechanical_speed")}
                values={getValues("maximumMechanicalSpeed", motors)}
                unit={t("msizer.ui.unit.rpm")}
              />
              <ComparatorLine
                title={t("msizer.ui.motor_filters.motor_length")}
                values={getValues("length", motors)}
                unit={t("msizer.ui.unit.mm")}
              />
              <ComparatorLine
                title={t("msizer.ui.motor_filters.holding_brake")}
                values={getValues("brake", motors).map((value) =>
                  // eslint-disable-next-line prettier/prettier
                  ["1", "Yes", true, "true"].includes(value)
                    ? "With"
                    : ["0", "No", false, "false"].includes(value)
                      ? "Without"
                      : value
                )}
              />
              <ComparatorLine
                title={t("msizer.ui.motor_filters.supply_voltage")}
                values={getValues("supplyVoltage", bundlesToCompare)}
                unit={t("msizer.ui.unit.v")}
              />
              <ComparatorLine
                title={t("msizer.ui.motor_filters.shaft_end")}
                values={getValuesFromTranslation(motors, "D_SHAFT_END", langTrad)}
              />
              <ComparatorLine
                title={t("msizer.ui.motor_filters.shaft_diameter")}
                values={getValues("shaftDiameter", motors)}
                unit={t("msizer.ui.unit.mm")}
              />
              <ComparatorLine
                title={t("msizer.ui.motor_filters.shaft_length")}
                values={getValues("shaftLength", motors)}
                unit={t("msizer.ui.unit.mm")}
              />
              <ComparatorLine
                title={t("msizer.ui.motor_filters.ip_degree_of_protection")}
                values={getValues("ipProtections", motors)}
              />
              <ComparatorLine
                title={t("msizer.ui.motor_filters.encoder")}
                values={getValuesFromTranslation(motors, "D_FEEDBACK_TYPE", langTrad)}
              />
              <ComparatorLine
                title={t("msizer.ui.motor_filters.connector_type")}
                values={getValuesFromTranslation(motors, "D_ELECTRICAL_CONNECTION", langTrad)}
              />
              <ComparatorLine
                title={t("msizer.ui.motor_filters.inertia")}
                values={getValues("inertiaMotor", motors)}
                unit={t("msizer.ui.unit.kg_cm_squared")}
              />
              <ComparatorLine
                title={t("msizer.ui.motor_filters.weight")}
                values={getValues("productWeight", motors)}
                unit={t("msizer.ui.unit.kg")}
              />
              <ComparatorLine
                title={t("msizer.ui.motor_filters.continuous_stall_current")}
                values={getValues("continuousStallCurrent", motors)}
                unit={t("msizer.ui.unit.a")}
              />
              <ComparatorLine
                title={t("msizer.ui.motor_filters.speed_feedback_resolution")}
                values={getValues("speedFeedbackResolution", motors)}
              />
              <ComparatorLine
                title={t("msizer.ui.motor_filters.output_current_3s_peak")}
                values={getValues("outputCurrent3SPeak", motors)}
                unit={t("msizer.ui.unit.a")}
              />
            </>
          )}

          {/* GEARBOX */}
          {hasGearboxes && (
            <>
              <ComparatorLine
                title={t("msizer.ui.gearbox").toUpperCase()}
                opened={showGearboxes}
                isSectionHeader
                values={gearboxes.map((gearbox) => gearbox?.commercialReference)}
                onClick={() => setShowGearboxes(!showGearboxes)}
              />

              {showGearboxes && (
                <>
                  <ComparatorLine isProductImages values={gearboxes.map((gearbox) => gearbox?.commercialReference)} />

                  <ComparatorLine
                    title={t("msizer.ui.gearbox_filters.component_type")}
                    values={getValuesTranslated(
                      `translationData[0].catalogue_product.characteristic_group_list.characteristic_group[0].characteristic_list.characteristic[1].valueIds[0].translation.${langTrad}`,
                      gearboxes
                    )}
                  />

                  <ComparatorLine
                    title={t("msizer.ui.gearbox_filters.gearbox_type")}
                    values={getValuesTranslated(
                      `translationData[0].catalogue_product.characteristic_group_list.characteristic_group[0].characteristic_list.characteristic[2].valueIds[0].translation.${langTrad}`,
                      gearboxes
                    )}
                  />

                  <ComparatorLine
                    title={t("msizer.ui.gearbox_filters.short_name")}
                    values={getValues("family", gearboxes)}
                  />

                  <ComparatorLine
                    title={t("msizer.ui.gearbox_filters.external_diameter")}
                    values={getValues("externalDiameter", gearboxes)}
                    unit={t("msizer.ui.unit.mm")}
                  />

                  <ComparatorLine
                    title={t("msizer.ui.gearbox_filters.input_diameter")}
                    values={getValues("inputDiameter", gearboxes)}
                    unit={t("msizer.ui.unit.mm")}
                  />

                  <ComparatorLine
                    title={t("msizer.ui.gearbox_filters.reduction_ratio")}
                    values={getValues("reductionRatio", gearboxes)}
                    unit=":1"
                  />

                  <ComparatorLine
                    title={t("msizer.ui.gearbox_filters.efficiency")}
                    values={getValues("efficiency", gearboxes)}
                    unit="%"
                  />

                  <ComparatorLine
                    title={t("msizer.ui.gearbox_filters.maximum_torsional_backlash")}
                    values={getValues("torsionalBacklash", gearboxes)}
                    unit={t("msizer.ui.unit.arc_min")}
                  />

                  <ComparatorLine
                    title={t("msizer.ui.gearbox_filters.shaft_moment_of_inertia")}
                    values={getValues("shaftMomentOfInertia", gearboxes)}
                    unit={t("msizer.ui.unit.kg_cm_squared")}
                  />

                  <ComparatorLine
                    title={t("msizer.ui.gearbox_filters.net_weight")}
                    values={getValues("productWeight", gearboxes)}
                    unit={t("msizer.ui.unit.kg")}
                  />

                  <ComparatorLine
                    title={t("msizer.ui.gearbox_filters.length")}
                    values={getValues("gearboxLength", gearboxes)}
                    unit={t("msizer.ui.unit.mm")}
                  />

                  <ComparatorLine
                    title={t("msizer.ui.gearbox_filters.continuous_output_torque")}
                    values={getValues("continuousOutputTorque", gearboxes)}
                    unit={t("msizer.ui.unit.nm")}
                  />
                  <ComparatorLine
                    title={t("msizer.ui.gearbox_filters.maximum_output_torque")}
                    values={getValues("maximumOutputTorque", gearboxes)}
                    unit={t("msizer.ui.unit.nm")}
                  />

                  <ComparatorLine
                    title={t("msizer.ui.gearbox_filters.ip_degree_of_protection")}
                    values={getValues("ipDegreeOfProtection", gearboxes)}
                  />
                </>
              )}
            </>
          )}

          {/* ADAPTATION KIT */}
          {hasAdaptationKits && (
            <>
              <ComparatorLine
                title={t("msizer.ui.adaptation_kit").toUpperCase()}
                opened={showAdaptationKits}
                isSectionHeader
                values={adaptationKits.map((adaptationKit) => adaptationKit?.commercialReference)}
                onClick={() => setShowAdaptationKits(!showAdaptationKits)}
              />

              {showAdaptationKits && (
                <>
                  <ComparatorLine
                    isProductImages
                    values={adaptationKits.map((adaptationKit) => adaptationKit?.commercialReference)}
                  />

                  <ComparatorLine
                    title={t("msizer.ui.adaptation_kit_attributes.component_type")}
                    values={getValuesTranslated(
                      `translationData[0].catalogue_product.characteristic_group_list.characteristic_group[0].characteristic_list.characteristic[1].valueIds[0].translation.${langTrad}`,
                      adaptationKits
                    )}
                  />

                  <ComparatorLine
                    title={t("msizer.ui.adaptation_kit_attributes.separate_part_destination")}
                    values={getValuesTranslated(
                      `translationData[0].catalogue_product.characteristic_group_list.characteristic_group[0].characteristic_list.characteristic[5].valueIds[0].translation.${langTrad}`,
                      adaptationKits
                    )}
                  />

                  <ComparatorLine
                    title={t("msizer.ui.adaptation_kit.kit_composition")}
                    values={getValues("kitComposition", adaptationKits)}
                  />

                  <ComparatorLine
                    title={t("msizer.ui.adaptation_kit.external_diameter")}
                    values={getValues("externalDiameter", adaptationKits)}
                    unit={t("msizer.ui.unit.mm")}
                  />

                  <ComparatorLine
                    title={t("msizer.ui.adaptation_kit.flange_size")}
                    values={getValues("flangeSize", adaptationKits)}
                    unit={t("msizer.ui.unit.mm")}
                  />

                  <ComparatorLine
                    title={t("msizer.ui.adaptation_kit.length")}
                    values={getValues("length", adaptationKits)}
                    unit={t("msizer.ui.unit.mm")}
                  />

                  <ComparatorLine
                    title={t("msizer.ui.adaptation_kit_attributes.weight")}
                    values={getValues("weight", adaptationKits)}
                    unit={t("msizer.ui.unit.kg")}
                  />
                </>
              )}
            </>
          )}

          <ComparatorLine
            title={t("msizer.ui.compare.select_bundle")}
            type="footer"
            headerBundles={dynamicBundlesToCompare}
            onSelect={(bundle) => {
              handleSelectBundle(bundle);
            }}
          />
          {isMobile && bundlesToCompare.length === 3 && (
            <div className="flex w-full mt-3 gap-3 text-base font-medium">
              <div className="flex w-full justify-between">
                <button
                  type="button"
                  onClick={() => {
                    changeFirstBundle();
                  }}
                >
                  <IoIosArrowBack />
                </button>
                <span>{firstBundleNum}</span>
                <button
                  type="button"
                  onClick={() => {
                    changeFirstBundle();
                  }}
                >
                  <IoIosArrowForward />
                </button>
              </div>
              <div className="flex w-full justify-between">
                <button
                  type="button"
                  onClick={() => {
                    changeSecondBundle();
                  }}
                >
                  <IoIosArrowBack />
                </button>
                <span>{secondBundleNum}</span>
                <button
                  type="button"
                  onClick={() => {
                    changeSecondBundle();
                  }}
                >
                  <IoIosArrowForward />
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
export default BundleComparator;
